import React from 'react';
import { Avatar } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Name = () => {
  return (
    <>
      <h4 className="mt-5">Lettered Avatars</h4>
      <p>
        Get lettered avatars by simply using the <i>name</i> prop.
      </p>
      <div className="btn-group btns mt-3">
        <Avatar className="single-btn" name='KS' />
        <Avatar className="single-btn" name='D' />
       
      </div>
      <Row className="mt-3" fluid>
        <code>
          {'import { Avatar } from "chic-ui";'}
          <br />
          {'<Avatar name="KS" />'}
          <br />
          {'<Avatar name="D" />'}
        </code>
      </Row>
    </>
  );
};

export default Name;
